import { RadioField, RadioInput } from '@flos/react-ui';
import type { YesNo_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';

const PetHealthyLastSixMonths = ({
    healthValue,
    handleHealthValueChange,
    disabled = false
}: {
    healthValue: YesNo_Top | undefined;
    handleHealthValueChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
}): React.JSX.Element => {
    return (
        <RadioField
            value={healthValue || ''}
            onChange={handleHealthValueChange}
            required
            disabled={disabled}
        >
            <RadioInput value={'Yes' as YesNo_Top} label="Ja" />
            <RadioInput value={'No' as YesNo_Top} label="Nej" />
        </RadioField>
    );
};

export default PetHealthyLastSixMonths;
